// extracted by mini-css-extract-plugin
export var layoutContainer = "_ah-0";
export var layoutContainerNoRounding = "_ah-6";
export var layoutContainerOpen = "_ah-5";
export var layoutContainerResizing = "_ah-1";
export var mainContent = "_ah-2";
export var resizeDivider = "_ah-3";
export var slidePanel = "_ah-4";